import { render, staticRenderFns } from "./ArchivedHistoryCard.vue?vue&type=template&id=549fcd40&scoped=true"
import script from "./ArchivedHistoryCard.vue?vue&type=script&setup=true&lang=ts"
export * from "./ArchivedHistoryCard.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./ArchivedHistoryCard.vue?vue&type=style&index=0&id=549fcd40&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "549fcd40",
  null
  
)

export default component.exports